import styled, { css } from 'styled-components';
import { BasePaginatorHeader, BasePaginatorListItem } from 'styles/components';
export {
  PaginatorColumn as Column,
  PaginatorActionsColumn as ActionsColumn,
  ActionButton,
  TrashIcon,
  ActivityIndicator,
  EmptyListPlaceholder,
  Button,
  FormRow,
} from 'styles/components';

export const Container = styled.div`
  margin-top: 32px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const baseGridCss = css`
  grid-template-columns: 50px 250px 150px 150px 150px auto;
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${baseGridCss}
`;


export const ListItem = styled(BasePaginatorListItem)`
  ${baseGridCss}
`;
